import { postRequest } from '@/core';
import { globalAddresses } from '@/requests';

export default async function newGlobalAddressRequest(address) {
	let url = globalAddresses.getPath();
	let response = await postRequest(url, {}, address);
	return response;
}
